import { t } from '@lingui/macro'
import { Text, View } from '@react-pdf/renderer'
import { getLabelFromTranslationData } from 'app/views/common/translationsCommon'
import {
    defaultFormPdfFontFamily,
    formPDFStyles,
    inuktitutFormPdfFontFamily
} from 'app/views/forms/pdf-components/FormPdf'
import FormPdfFillArea from 'app/views/forms/pdf-components/FormPdfFillArea'
import { pdfDefaultFontSize } from 'app/views/forms/pdf-components/PDFCommon'
import { myI18n } from 'translation/I18nConnectedProvider'
import caProvinces from './canada_provinces.json'

const styles = {
  text: {
    fontSize: pdfDefaultFontSize,
    fontFamily: defaultFormPdfFontFamily,
    marginLeft: 8
  },
  question: {
    fontSize: pdfDefaultFontSize,
    fontFamily: defaultFormPdfFontFamily,
    marginTop: 8,
    marginBottom: 8
  },
  description: {
    fontSize: pdfDefaultFontSize - 2,
    fontFamily: defaultFormPdfFontFamily,
    fontStyle: 'italic',
    marginTop: 4,
    marginBottom: 4
  },
  required: {
    fontSize: pdfDefaultFontSize - 2,
    fontFamily: defaultFormPdfFontFamily,
    fontStyle: 'italic',
    marginLeft: 4,
    marginTop: 4
  },
  row: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 4
  },
  listItem: {
    flexDirection: 'row',
    marginBottom: 4,
    width: '48%',
    flexWrap: 'nowrap'
  },
  odd: {
    marginLeft: '4%'
  }
}

export const FormCensusDivisionFillablePdf = ({
  value,
  elementType,
  typeProps,
  langVersion,
  title,
  helpText,
  tooltip,
  altLabelPlacement,
  index,
  ...props
}) => {
  const onlyInOneProvince = typeProps?.avaliableProvinces?.length === 1
  const pilotPhase = typeProps.connectedTo[0].pilotPhase
  const showPilotPhase = !onlyInOneProvince && pilotPhase

  if (langVersion === 'iu-cans') {
    styles.description.fontFamily = inuktitutFormPdfFontFamily
    styles.question.fontFamily = inuktitutFormPdfFontFamily
    styles.text.fontFamily = inuktitutFormPdfFontFamily
    styles.required.fontFamily = inuktitutFormPdfFontFamily
  }

  const provinceLabels = caProvinces.features.map(province => {
    if (langVersion === 'iu-cans') {
      if (province.properties.nameIU) {
        return province.properties.nameIU
      } else {
        return getLabelFromTranslationData({
          data: { portalTranslationId: province.properties.name }
        })
      }
    } else if (langVersion === 'en') {
      return province.properties.name
    } else if (langVersion === 'fr') {
      return province.properties.nom
    }
    return province.properties.name
  })

  let n = 1

  const sub = {
    mainScope: n++,
    pilotQuestion: showPilotPhase ? n++ : null,
    pilotScope: showPilotPhase ? n++ : null,
    provinceQuestion: !onlyInOneProvince ? n++ : null,
    municipalQuestion: n++,
    regionalQuestion: n++
  }

  return (
    <View>
      <View wrap={false}>
        <Text style={styles.question}>
          {`${index}.${sub.mainScope}`}
          {' '}
          {myI18n._(t`CENZUS_DIVISION_ELEMENT_SCOPE`)}
          {` (${myI18n._(t`Required`)})`}
        </Text>

        <View style={styles.row}>
          <View style={formPDFStyles.radioCheck} />
          <Text style={styles.text}>
            {myI18n._(t`CENZUS_DIVISION_ELEMENT_SCOPE_NEIGHBOURHOOD_OPTION`)}
          </Text>
        </View>
        <View style={styles.row}>
          <View style={formPDFStyles.radioCheck} />
          <Text style={styles.text}>
            {myI18n._(t`CENZUS_DIVISION_ELEMENT_SCOPE_MUNCIPAL_OPTION`)}
          </Text>
        </View>
        <View style={styles.row}>
          <View style={formPDFStyles.radioCheck} />
          <Text style={styles.text}>
            {myI18n._(t`CENZUS_DIVISION_ELEMENT_SCOPE_REGIONAL_OPTION`)}
          </Text>
        </View>
        <View style={styles.row}>
          <View style={formPDFStyles.radioCheck} />
          <Text style={styles.text}>
            {myI18n._(
              t`CENZUS_DIVISION_ELEMENT_SCOPE_PROVINCE_OR_TERRITORY_OPTION`
            )}
          </Text>
        </View>
        {showPilotPhase && (
          <View style={styles.row}>
            <View style={formPDFStyles.radioCheck} />
            <Text style={styles.text}>
              {myI18n._(
                t`CENZUS_DIVISION_ELEMENT_SCOPE_National_OPTION`
              )}
            </Text>
          </View>
        )}
      </View>

      {showPilotPhase && (
        <View wrap={false}>
          <View style={{ marginTop: 8 }}>
            <Text style={styles.description}>
              {myI18n._(t`PDF_IF_SELECTED_CONDITION`)}{' '}
              {myI18n._(t`PDF_CENZUS_DIVISION_NATIONAL`)}{' '}
              {myI18n._(t`PDF_IN_QUESTION`)}{' '}
              {`${index}.${sub.mainScope}`}{', '}
              {myI18n._(t`PDF_QUESTION_REQUIRED`)}
            </Text>
          </View>
          <Text style={styles.question}>
            {`${index}.${sub.pilotQuestion}`}
            {' '}
            {myI18n._(t`CENZUS_DIVISION_ELEMENT_PILOT_PHASE_QUESTION`)}
          </Text>
          <View style={styles.row}>
            <View style={formPDFStyles.radioCheck} />
            <Text style={styles.text}>
              {myI18n._(t`Yes`)}
            </Text>
          </View>
          <View style={styles.row}>
            <View style={formPDFStyles.radioCheck} />
            <Text style={styles.text}>
              {myI18n._(t`No`)}
            </Text>
          </View>
        </View>)}

      {showPilotPhase && (
        <View wrap={false}>
          <View style={{ marginTop: 8 }}>
            <Text style={styles.description}>
              {myI18n._(t`PDF_IF_SELECTED_CONDITION`)}{' '}
              {myI18n._(t`Yes`)}{' '}
              {myI18n._(t`PDF_IN_QUESTION`)}{' '}
              {`${index}.${sub.pilotQuestion}`}{', '}
              {myI18n._(t`PDF_QUESTION_REQUIRED`)}
            </Text>
          </View>
          <Text style={styles.question}>
            {`${index}.${sub.pilotScope}`}
            {' '}
            {myI18n._(t`CENZUS_DIVISION_ELEMENT_SELECT_PILOT_PHASE_SCOPE`)}
          </Text>
          <View style={styles.row}>
            <View style={formPDFStyles.radioCheck} />
            <Text style={styles.text}>
              {myI18n._(t`CENZUS_DIVISION_ELEMENT_SCOPE_NEIGHBOURHOOD_OPTION`)}
            </Text>
          </View>
          <View style={styles.row}>
            <View style={formPDFStyles.radioCheck} />
            <Text style={styles.text}>
              {myI18n._(t`CENZUS_DIVISION_ELEMENT_SCOPE_MUNCIPAL_OPTION`)}
            </Text>
          </View>
          <View style={styles.row}>
            <View style={formPDFStyles.radioCheck} />
            <Text style={styles.text}>
              {myI18n._(t`CENZUS_DIVISION_ELEMENT_SCOPE_REGIONAL_OPTION`)}
            </Text>
          </View>
          <View style={styles.row}>
            <View style={formPDFStyles.radioCheck} />
            <Text style={styles.text}>
              {myI18n._(
                t`CENZUS_DIVISION_ELEMENT_SCOPE_PROVINCE_OR_TERRITORY_OPTION`
              )}
            </Text>
          </View>
        </View>)}

      {!onlyInOneProvince && (
        <View wrap={false}>
          <View style={{ marginTop: 8 }}>
            <Text style={styles.description}>
              {myI18n._(t`PDF_IF_SELECTED_CONDITION`)}{' '}
              {myI18n._(t`CENZUS_DIVISION_ELEMENT_SCOPE_PROVINCE_OR_TERRITORY_OPTION`)}{' '}
              {myI18n._(t`PDF_IN_QUESTION`)}{' '}
              {`${index}.${sub.mainScope}`}{' '}
              {showPilotPhase && `${myI18n._(t`PDF_OR`)} ${index}.${sub.pilotScope}, `}
              {myI18n._(t`PDF_QUESTION_REQUIRED`)}
            </Text>
          </View>
          <Text style={styles.question}>
            {`${index}.${sub.provinceQuestion}`}
            {' '}
            {myI18n._(t`CENZUS_DIVISION_ELEMENT_PROVINCE_OR_TERRITORY_QUESTION`)}
          </Text>
          <View style={styles.row}>
            {provinceLabels.map((province, index) => {
              const isOdd = index % 2 === 1
              const _styles = isOdd
                ? [styles.listItem, styles.odd]
                : [styles.listItem]
              return (
                <View style={_styles} key={index} wrap={false}>
                  <View style={formPDFStyles.radioCheck} />
                  <Text style={styles.text}>
                    {province}
                  </Text>
                </View>
              )
            })}
          </View>
        </View>
      )}

      <View wrap={false}>
        <View style={{ marginTop: 8 }}>
          <Text style={styles.description}>
            {myI18n._(t`PDF_IF_SELECTED_CONDITION`)}{' '}
            {myI18n._(t`PDF_CENZUS_DIVISION_MUNICIPAL_OR_NEIGHBOURHOOD`)}{' '}
            {myI18n._(t`PDF_IN_QUESTION`)}{' '}
            {`${index}.${sub.mainScope}`}{' '}
            {showPilotPhase && `${myI18n._(t`PDF_OR`)} ${index}.${sub.pilotScope}, `}
            {myI18n._(t`PDF_QUESTION_REQUIRED`)}
          </Text>
        </View>
        <Text style={styles.question}>
          {`${index}.${sub.municipalQuestion}`}
          {' '}
          {myI18n._(t`FORM_CENZUS_DIVISION_PDF_CENSUS_DIVISION_MUNICIPAL`)}
        </Text>
        <View style={styles.row}>
          <FormPdfFillArea lines={1} />
        </View>
      </View>

      <View wrap={false}>
        <View style={{ marginTop: 8 }}>
          <Text style={styles.description}>
            {myI18n._(t`PDF_IF_SELECTED_CONDITION`)}{' '}
            {myI18n._(t`PDF_CENZUS_DIVISION_REGIONAL`)}{' '}
            {myI18n._(t`PDF_IN_QUESTION`)}{' '}
            {`${index}.${sub.mainScope}`}{' '}
            {showPilotPhase && `${myI18n._(t`PDF_OR`)} ${index}.${sub.pilotScope}, `}
            {myI18n._(t`PDF_QUESTION_REQUIRED`)}
          </Text>
        </View>
        <Text style={styles.question}>
          {`${index}.${sub.regionalQuestion}`}
          {' '}
          {myI18n._(t`FORM_CENZUS_DIVISION_PDF_CENSUS_DIVISION_REGIONAL`)}
        </Text>
        <View style={styles.row}>
          <FormPdfFillArea lines={1} />
        </View>
      </View>
    </View>
  )
}
